<template>
    <v-card>
        <!-- <v-container class="grey lighten-5"  v-role="'func'">
            <v-btn  class="mx-2" fab dark color="primary" @click="$router.push('/estudante-historico')"> <v-icon dark>arrow_back</v-icon></v-btn>
        </v-container> -->
        <guiatransferencia v-if="isguiatransferencia"/>
        <fichadadosbiograficoacademico v-if="isfichadadosbiograficoacademico"/>
        <historicoacademico v-if="ishistoricoacademico"/>
        <cartaoescolar v-if="iscartaoescolar"/>
        <declaracaonotas v-if="isdeclaracaonotas"/>
        <declaracao v-if="isdeclaracao"/>
        <cartarecomendacao v-if="iscartarecomendacao"/>
    </v-card>
</template>

<script>
const ls = require('local-storage')
export default {
  components: {
    // @ts-ignore
    // @ts-ignore
    guiatransferencia: () => import('../tec-ped/componentes/guiatransferencia.vue'),
    fichadadosbiograficoacademico: () => import('../tec-ped/componentes/fichadadosbiografico.vue'),
    historicoacademico: () => import('../tec-ped/componentes/historicoacademico.vue'),
    cartaoescolar: () => import('../tec-ped/componentes/cartao.vue'),
    declaracaonotas: () => import('../tec-ped/componentes/declaracao_nota.vue'),
    declaracao: () => import('../tec-ped/componentes/declaracao.vue'),
    cartarecomendacao: () => import('../tec-ped/componentes/carta.vue')
  },
  data: () => ({
    relatorio: ls.get('relatorio-estudante')
  }),
  computed: {
    ishistoricoacademico () {
      return !!((this.relatorio && this.relatorio.id === 1))
    },
    isfichadadosbiograficoacademico () {
      return !!((this.relatorio && this.relatorio.id === 3))
    },
    iscartarecomendacao () {
      return !!((this.relatorio && this.relatorio.id === 4))
    },
    isguiatransferencia () {
      return !!((this.relatorio && this.relatorio.id === 5))
    },
    iscartaoescolar () {
      return !!((this.relatorio && this.relatorio.id === 6))
    },
    isdeclaracaonotas () {
      return !!((this.relatorio && this.relatorio.id === 7))
    },
    isdeclaracao () {
      return !!((this.relatorio && this.relatorio.id === 8))
    }
  },
  created  () {
  },
  async mounted () {

  },
  methods: {

  }
}

</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
